import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { IValidateMobileRequest } from '../../../../core/models/validate-mobile.model';
import { Store } from '@ngrx/store';
import * as validateMobile from '../../actions/validate-mobile-number.actions';
import * as checkRegistration from '../../actions/check-if-registered.actions';
import * as mobileValidationSelector from '../../selectors/validate-mobile-number.selectors';
import { Observable, Subscription } from 'rxjs';
import { IGenericError, ErrorResponse } from '../../../../core/models/generic-models';

@Component({
  selector: 'app-login',
  templateUrl: './mobile-validation.component.html',
  styleUrls: ['./mobile-validation.component.css']
})
export class MobileValidationComponent {
  isMobileValidationLoading$: Observable<boolean>;
  mobileValidationFailure$: Observable<IGenericError<ErrorResponse>>;
  getCustomerHomeAddressSubs: Subscription = new Subscription();

  mobileForm = this.fb.group({
    mobile: new UntypedFormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]+$'),
      Validators.minLength(10),
      Validators.maxLength(10) // <-- Here's how you pass in the custom validator.
    ])
  });
  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private store: Store
  ) {}

  goToPasscode() {
    const req: IValidateMobileRequest = {
      dialingCode: '+27',
      mobileNumber: this.mobileForm.value.mobile
    };
    this.store.dispatch(validateMobile.checkValidMobileNumberRequest({ request: req }));
    this.store.dispatch(checkRegistration.checkRegisterRequiredRequest({ request: req }));
    this.isMobileValidationLoading$ = this.store.select(mobileValidationSelector.getValidateMobileIsLoading);
    this.mobileValidationFailure$ = this.store.select(mobileValidationSelector.getMobileValidationFailure);
  }

  get mobile() {
    return this.mobileForm.get('mobile');
  }
}
